import React, {useEffect, useState} from "react";
import {MySearchNavbar, ResSearchContainer, SearchBar} from "./CasellaRicercaHeader.style";
import { Helpers } from "@tpd-web-common-libs/nodejs-library";
import SearchSemanticoService from "../../services/search-semantico.service";

type TLowerHeaderDesktopProps = {
  __host__: any;
  id: string;
  isEditMode: boolean;
  config: any;
};

const CasellaRicercaHeader = (props: TLowerHeaderDesktopProps) => {
  const {
    __host__,
    isEditMode,
    id: containerID,
    config,
  } = props;

  config.config = config.config ? config.config : {
    mod: 'DESKTOP',
    paginaRisultati: '/ricerca',
  }

  let inputValue = '';
  let timer = 0;
  const MIN_CHARS_TO_AUTOCOMPLETE = 3;

  const isServerSide = Helpers.EnvironmentHelper.isServerSide();

  //const isHCLAuthoringPage = Helpers.PageHelper.isHCLAuthoringPage();

  const [searchString, setSearchString] = useState('');
  const [responseSuggestions, setResponseSuggestions] = useState([]);

  const searchSemanticoService = new SearchSemanticoService();

  const canDoSearch = (): boolean => searchString?.length !== 0;
  const hasResults = (): boolean => responseSuggestions?.length > 0;


  useEffect(() => {
    const url = Helpers.PageHelper.isHCLAuthoringPage()?__host__.url : __host__.router.asPath ;
    const path = url.split("?")[1];
    const params = new URLSearchParams("?" + path);
    const newSearchParams = params.get("cerca") || "";
    setSearchString(newSearchParams);
  }, []);


  /**
   * Digitazione nella casella di ricerca per ottenere suggerimenti
   * @param event
   */
  const getSuggestions = (event: any) => {
    inputValue = event.target.value;

    if (
      event.keyCode !== 13 &&
      event.keyCode !== 37 &&
      event.keyCode !== 38 &&
      event.keyCode !== 39 &&
      event.keyCode !== 40
    ) {
      if (
        inputValue.length === 0 ||
        inputValue.length > MIN_CHARS_TO_AUTOCOMPLETE
      ) {
        if (timer > 0) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          if (canDoSuggestion(inputValue)) {
            getSuggestionsService(inputValue);
          }
        }, 200) as any;
      } else {
        if (canDoSuggestion(inputValue)) {
          getSuggestionsService(inputValue);
        }
      }
    }
    else if (event.keyCode === 13) {
      doSearch(inputValue);
    }
  }


  /**
   * Controlla se è possibile fare una ricerca con un minimo di caratteri
   * @param searchText
   */
  const canDoSuggestion = (searchText:string): boolean => {
    return searchText !== null &&
      searchText !== undefined &&
      (searchText.length >= MIN_CHARS_TO_AUTOCOMPLETE ||
      searchText.length === 0);
  }


  /**
   * Esegue la ricerca e reindirizza alla pagina dei risultati
   * @param searchItem
   */
  const doSearch = (searchItem:string) => {
    setResponseSuggestions([]);
    if (config && config.config != null) {
      let searchParams = '';
      if (canDoSearch()) {
        searchParams +=
          '?cerca=' + encodeURIComponent(searchItem);
        Helpers.RouterHelper.goTo(config.config.paginaRisultati + searchParams, {
          openNewTab: false,
        });
      }
    }
  };


  /**
   * Chiude i box suggerimenti
   */
  const closeSuggestions = () =>
    setTimeout(() => (setResponseSuggestions([])), 500);


  /**
   * Ricevo i suggerimenti ricerca dal servizio
   * @param searchText
   */
  const getSuggestionsService = (searchText:string) => {
    const body = {
      input: searchText
    }
    searchSemanticoService
      .getSuggestions(body)
      .then((response) => {
        setResponseSuggestions(response.bdy);
      })
      .catch((err) => console.error(err));
  }

  return (
    <SearchBar className="widget-global-style">
      <MySearchNavbar className="input-group">
        <input
          type="text"
          className="form-control"
          placeholder="FAI UNA DOMANDA"
          name="cercaSearchSemanticoMod2"
          value={searchString}
          onKeyUp={(event) => {
            getSuggestions(event);
          }}
          onBlur={closeSuggestions}
          onChange={(event) => {
            setSearchString(event.target.value);
          }}
        />
        {!canDoSearch() && (
          <span
            className="input-group-addon clear-addon-style"
            id="tpd_search_button_click_no_mobile"
            onClick={() => doSearch(searchString)}
          ><i aria-hidden="true" className="tpd_search_icon icon-Cerca"></i
          ></span>
        )}

        {canDoSearch() && (
          <span
            className={`input-group-addon ${!isServerSide ? 'active' : ''}`}
            id="tpd_search_button_click_no_mobile"
            onClick={() => doSearch(searchString)}
          ><i aria-hidden="true" className="tpd_search_icon icon-Cerca"></i
          ></span>
        )}
      </MySearchNavbar>

      {hasResults() && (
      <ResSearchContainer>
        <div className="bk_154 tpd_bk154_desktop">
          <div className="tpd_separatorTop"></div>

          {
            responseSuggestions.map((suggestionItem, i) => {
              return (<div key={i} className="tpd_resSearchBox">
                <div className="tpd_label" onClick={() => {
                  doSearch(suggestionItem)
                }}>{suggestionItem}</div>
              </div>)
            })
          }

          <div className="tpd_separator"></div>

          <div className="tpd_resSearchViewAll">
            <a href="javascript:void(0);" onClick={() => doSearch(searchString)}>
              Visualizza tutti i risultati per <strong>{searchString}</strong>
            </a>
          </div>
        </div>
      </ResSearchContainer>
      )}
    </SearchBar>
  );
};

export default CasellaRicercaHeader;
